import React from "react";
import back from '../image/back.png';

const GSTRefund = () => {
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };
  return (
    <>
      <div className="bg-white rounded-lg">
        {/* Background Section */}
        <div
          className="bg-cover h-64 flex flex-col justify-center items-center text-center"
          style={{
            backgroundImage:`url(${back})`,
          }}
        >
          <h1 className="text-2xl md:text-3xl font-bold text-blue-700">
            GST Refud  Services
          </h1>
          <p className="mt-2 text-black font-semibold text-lg md:text-2xl px-4 md:px-0">
            Maximize Your GST Refunds with Sanjay K Nathani & Co.
          </p>
        </div>

        {/* Description Section */}
        <div className="px-6 py-10 md:px-20 lg:px-40">
          <p className="text-gray-700 leading-relaxed mb-6 text-sm md:text-base">
            At Sanjay K Nathani & Co., we understand that claiming GST refunds can be a complex and time-consuming process for businesses. That’s why we offer GST refund services to help businesses maximize their GST refunds and improve their cash flow.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6 text-sm md:text-base">
            Our team of GST experts can assist you with all aspects of GST refund services, including identifying eligible GST refunds, preparing and filing GST refund applications, and following up with the tax authorities for a timely refund.
          </p>

          {/* List of Services */}
          <ol className="list-disc list-inside space-y-2 text-gray-700 text-sm md:text-base">
            <li>Identifying and reviewing eligible GST refunds</li>
            <li>Preparing and filing GST refund applications</li>
            <li>Following up with the tax authorities for a timely refund</li>
            <li>Compliance with GST regulations and requirements</li>
            <li>Assistance with GST audits and assessments</li>
          </ol>
        </div>

        {/* Contact Section */}
        <div className="mt-8 bg-gray-50 p-6 rounded-lg shadow-sm mx-4 md:mx-20 lg:mx-40">
          <h2 className="text-lg md:text-xl font-bold text-gray-800 mb-4">Get in touch</h2>
          <p className="text-gray-600 mb-6 text-sm md:text-base">
            If you have any queries or questions, please reach out to us by clicking on the contact button and filling out the form.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            {/* Make Appointment Button */}
            <button  onClick={handleAppointmentClick} className="px-6 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition duration-200 w-full sm:w-auto">
              Make Appointment
            </button>

            {/* Contact Us Button */}
            <button className="px-6 py-2 bg-[#005A8C] text-white rounded  transition duration-200 w-full sm:w-auto">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default GSTRefund;